import { render, staticRenderFns } from "./HolaSSO.vue?vue&type=template&id=318c52da&scoped=true"
import script from "./HolaSSO.vue?vue&type=script&lang=js"
export * from "./HolaSSO.vue?vue&type=script&lang=js"
import style0 from "./HolaSSO.vue?vue&type=style&index=0&id=318c52da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318c52da",
  null
  
)

export default component.exports